import type React from 'react'
import type { Dispatch, SetStateAction } from 'react'

import { PaginationContainer, PaginationStyled } from './styles'

export const INITIAL_PAGE = 1
export const ITEMS_PER_PAGE = 10

export interface PaginationParams {
  currentPage: number
  totalItems: number
}

export interface QueryPagination {
  page: number
  perPage?: number
}

export interface PaginationProps {
  currentPage: number
  setCurrentPage: Dispatch<SetStateAction<number>> | ((value: number) => void)
  numberOfItems?: number
  numberOfPages?: number
  itemsPerPage?: number
  disabled?: boolean
}

export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  setCurrentPage,
  numberOfItems,
  numberOfPages = numberOfItems && numberOfItems > 0
    ? Math.ceil(numberOfItems / ITEMS_PER_PAGE)
    : 1,
  itemsPerPage,
  disabled,
}) => {
  if (!numberOfItems || numberOfItems === 0) {
    return null
  }

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    if (value !== null) {
      setCurrentPage(value)
    }
  }

  const handleItemCounter = () => {
    if (numberOfItems && itemsPerPage) {
      const firstItem = 1 + itemsPerPage * (currentPage - 1)
      const lastItem = itemsPerPage * currentPage
      if (lastItem > numberOfItems) {
        return `${firstItem} - ${numberOfItems} de ${numberOfItems}`
      } else {
        return `${firstItem} - ${lastItem} de ${numberOfItems}`
      }
    }
  }

  return (
    <PaginationContainer>
      <PaginationStyled
        boundaryCount={1}
        count={numberOfPages}
        defaultPage={1}
        disabled={disabled}
        onChange={handleChange}
        page={currentPage}
        shape="rounded"
        siblingCount={1}
      />
      {!!numberOfItems && itemsPerPage && <p>{handleItemCounter()}</p>}
    </PaginationContainer>
  )
}
